exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".CopyRightBox .table {\n  width: 100%;\n  display: table;\n  border-collapse: collapse;\n  font-size: 0.16rem;\n}\n.CopyRightBox .table .table-view {\n  display: table-row;\n}\n.CopyRightBox .table .table-view .table-clumn {\n  display: table-cell;\n  word-wrap: break-word;\n  overflow: hidden;\n  width: 10%;\n  vertical-align: middle;\n  border: 0.5px solid #999;\n  word-break: break-all;\n  text-align: center;\n  height: 30px;\n}\n.CopyRightBox .table .title {\n  color: #333;\n  height: 50px;\n}\n.CopyRightBox .table .grey {\n  color: #666;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/copyright/index.less
// module id = 442
// module chunks = 0